import { type FC, useCallback } from 'react';
import cx from 'classnames';

// @ts-expect-error - MarkedEditor doesn't have TypeScript definitions yet
import MarkedEditor from 'src/components/MarkedEditor';
import type { SlateValue } from 'src/lib/slate';

import { useStyles } from './useStyles';

interface Props {
  className?: string;
  content: SlateValue;
  onChange: (value: SlateValue) => void;
  onFocusChange?: (value: boolean) => void;
  disabled?: boolean;
  hideMarks?: boolean;
  setEditor?: (editor: unknown) => void;
}

export const VariationEditableContent: FC<Props> = ({
  className,
  content,
  onChange,
  onFocusChange,
  disabled = false,
  hideMarks = false,
  setEditor,
  ...restProps
}) => {
  const styles = useStyles();

  const handleChange = useCallback(
    (value: SlateValue) => {
      onChange(value);
    },
    [onChange]
  );

  const handleFocusChange = useCallback(
    (value: boolean) => {
      if (onFocusChange) {
        onFocusChange(value);
      }
    },
    [onFocusChange]
  );

  return (
    <MarkedEditor
      className={cx(styles.root, className)}
      value={content}
      onChange={handleChange}
      onFocusChange={handleFocusChange}
      readOnly={disabled}
      hideMarks={hideMarks}
      setEditor={setEditor}
      {...restProps}
    />
  );
};

VariationEditableContent.displayName = 'VariationEditableContent';
